import { render, staticRenderFns } from "./VendorTypes.vue?vue&type=template&id=35aab544"
import script from "./VendorTypes.vue?vue&type=script&lang=js"
export * from "./VendorTypes.vue?vue&type=script&lang=js"
import style0 from "./VendorTypes.vue?vue&type=style&index=0&id=35aab544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports